// extracted by mini-css-extract-plugin
export default {"image":"FileListGalleryItemThumbnail_image__4iFut"};